<template>
  <div class="detail" style="height: 100%">
    <div class="content" v-show="item.id" style="padding: 40px">
      <Row style="position: relative">
        <p
          style="
            font-size: 20px;
            font-weight: 800;
            color: #000;
            max-width: 50%;
            min-width: 10%;
            float: left;
          "
        >
          {{ item.title }}
        </p>
        <div style="float: left; margin-left: 10px; max-width: 35%">
          <Tag v-for="item1 in item.tag" :key="item1.label">{{
            item1.name
          }}</Tag>
        </div>
        <div
          span="2"
          offset="1"
          style="
            display: flex;
            justify-content: space-between;
            min-width: 10%;
            position: absolute;
            right: 0;
          "
        >
          <Button type="primary">编辑</Button>
          <Button type="primary" :to="{ name: 'AcademicCommunity' }"
            >返回</Button
          >
        </div>
      </Row>
      <Row>
        <Col
          span="24"
          style="margin-top: 20px; display: flex; align-items: center"
        >
          <img
            src="../assets/doctor.png"
            alt="0.0"
            style="
              width: 14px;
              height: 14px;
              border-radius: 50%;
              align-items: center;
            "
          />
          <a href="#" style="margin-left: 10px; align-items: center">{{
            item.author
          }}</a>
          <span style="margin-left: 30px; color: #aaa">
            {{ item.time }}
          </span>
        </Col>
      </Row>
      <Row>
        <Col span="6" offset="9">
          <img
            src="../assets/doctor.png"
            alt="0.0"
            style="height: 220px; width: 100%; border: 1px solid #eee"
        /></Col>
      </Row>
      <Row style="padding-left: 10px; margin-top: 30px">
        <Col span="24" style="border-left: 3px solid #ccc; padding-left: 20px">
          {{ item.subhead }}
        </Col>
      </Row>
      <Row style="margin-top: 30px; padding-left: 10px">
        <Col span="24">
          {{ item.detail }}
        </Col>
      </Row>
      <Row
        style="
          margin-top: 30px;
          border-bottom: 1px solid #eee;
          padding-bottom: 20px;
        "
      >
        <Col span="24">
          <div class="icon" style="display: flex; margin-top: 20px">
            <p
              style="
                border-right: 1px solid #ccc;
                color: #aaa;
                padding-right: 20px;
                width: 92px;
                display: relative;
              "
            >
              <img
                src="../assets/doctor.png"
                alt="0.0"
                style="
                  width: 32px;
                  height: 32px;
                  margin-right: 5px;
                  cursor: pointer;
                "
              />
              <span style="position: absolute; top: 28px">{{
                item.collectNum
              }}</span>
            </p>
            <p
              style="
                color: #aaa;
                padding-left: 20px;
                width: 92px;
                display: relative;
              "
            >
              <img
                src="../assets/doctor.png"
                alt="0.0"
                style="
                  width: 32px;
                  height: 32px;
                  margin-right: 5px;
                  cursor: pointer;
                "
              /><span style="position: absolute; top: 28px">{{
                item.praiseNum
              }}</span>
            </p>
          </div>
        </Col>
      </Row>
      <Row style="margin-top: 10px">
        <Col span="24">
          <p style="font-size: 18px; color: #1890ff; font-weight: 700">
            讨论列表
          </p>
        </Col>
      </Row>
      <Row style="margin-top: 5px">
        <Col span="2" offset="11" style="font-size: 12px; color: #cccccc">
          共{{ item.discussNum }}条评论
        </Col>
      </Row>
      <Row>
        <Col span="15">
          <CommentMod :commentData="commentlist"></CommentMod>
        </Col>
      </Row>
    </div>
    <!-- 当用户通过路由进入时，显示以下内容 -->
    <div
      v-show="!item.id"
      style="width: 100%; font-size: 30px; text-align: center; margin-top: 20%"
    >
      请重新点击文章进入详情页！
    </div>
  </div>
</template>

<script>
import CommentMod from "../components/CommentMod";
import { Row, Col, Button, Tag } from "view-design";
export default {
  components: { Row, Col, Button, Tag, CommentMod },
  data() {
    return {
      commentlist: [
        {
          name: "兆铭瑞",
          img: "../assets/doctor.png",
          introduce: "青岛大学明航医院 消化外科",
          commenttime: "2021-03-06 10:15:20",
          replynum: "5", //回复条数
          commentcont: "收到明天会处理",
          replyShow: false,
          replyData: [
            {
              replyname: "李医生",
              Repliedname: "王医生",
              replytime: "2021-03-06 10:15:20",
              replycont: "回复内容回复内容回复内容回复内容回复内容",
            },
            {
              replyname: "王医生",
              Repliedname: "李医生",
              replytime: "2021-03-06 10:15:20",
              replycont: "回复内容回复内容回复内容回复内容回复内容",
            },
            {
              replyname: "回复人",
              Repliedname: "被回复人",
              replytime: "2021-03-06 10:15:20",
              replycont: "回复内容回复内容回复内容回复内容回复内容",
            },
            {
              replyname: "回复人",
              Repliedname: "被回复人",
              replytime: "2021-03-06 10:15:20",
              replycont: "回复内容回复内容回复内容回复内容回复内容",
            },
            {
              replyname: "尼古拉斯",
              Repliedname: "赵四",
              replytime: "2021-03-06 10:15:20",
              replycont:
                "回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容回复内容",
            },
          ],
        },
      ],
      item: {},
    };
  },
  created() {
    this.item = { ...this.$route.params.item };
    this.$emit("funChangeTitle", "文章详情", "5-1");
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
.detail {
  .content {
    // .tag {
    //   margin-top: 3px;
    //   margin-left: 5px;
    //   padding: 1px 6px;
    //   background-color: rgb(247, 247, 247);
    //   border: 1px solid rgb(235, 235, 235);
    //   border-radius: 3px;
    // }
  }
}
</style>